/**
 * This file holds all the tyoes of actions.
 * To be used in actions and reducers
 */

const types = {
  CHECK_NEED_REGISTER: 'CHECK_NEED_REGISTER',
  REGISTER_USER: 'REGISTER_USER',
  AUTHENTICATE_USER: 'AUTHENTICATE_USER',
  VERIFY_MAGIC_CODE: 'VERIFY_MAGIC_CODE',
  VERIFY_SEND_TOKEN: 'VERIFY_SEND_TOKEN',
  CHECK_LOGGEDIN: 'CHECK_LOGGEDIN',
  VERIFY_INVITE_TOKEN: 'VERIFY_INVITE_TOKEN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  GET_LOGIN_PROVIDER_INFO: 'GET_LOGIN_PROVIDER_INFO',
  LOGOUT_USER: 'LOGOUT_USER',
  REWELCOME: 'REWELCOME',
  SET_NEED_VERIFY: 'SET_NEED_VERIFY',

  UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
  UPDATE_USER_AVATAR: 'UPDATE_USER_AVATAR',
  DELETE_USER_AVATAR: 'DELETE_USER_AVATAR',
  CHANGE_FILE: 'CHANGE_FILE',
  CHANGE_CROP: 'CHANGE_CROP',
  LOAD_IMAGE: 'LOAD_IMAGE',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  UPDATE_USER_PASSWORD: 'UPDATE_USER_PASSWORD',
  SET_USER_PASSWORD: 'SET_USER_PASSWORD',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  LOAD_SITE_APPLICATIONS: 'LOAD_SITE_APPLICATIONS',
  LOAD_SITE_APPLICATION: 'LOAD_SITE_APPLICATION',
  ADD_SITE_APPLICATION: 'ADD_SITE_APPLICATION',
  UPDATE_SITE_APPLICATION: 'UPDATE_SITE_APPLICATION',
  SEARCH_USERS: 'SEARCH_USERS',
  IMPERSONATE_USER: 'IMPERSONATE_USER',

  /* ENTERPRISE */
  ADD_ENTERPRISE: 'ADD_ENTERPRISE',
  UPDATE_ENTERPRISE: 'UPDATE_ENTERPRISE',
  LOAD_ENTERPRISE: 'LOAD_ENTERPRISE',
  ADD_ENTERPRISE_DOMAIN: 'ADD_ENTERPRISE_DOMAIN',
  FETCH_ENTERPRISE_DOMAIN_SAML_METADATA: 'FETCH_ENTERPRISE_DOMAIN_SAML_METADATA',
  UPDATE_ENTERPRISE_DOMAIN_SAML: 'UPDATE_ENTERPRISE_DOMAIN_SAML',
  FETCH_ENTERPRISE_USERS: 'FETCH_ENTERPRISE_USERS',
  CLAIM_ENTERPRISE_USERS: 'CLAIM_ENTERPRISE_USERS',
  FORCE_SAML_ON_ENTERPRISE_USERS: 'FORCE_SAML_ON_ENTERPRISE_USERS',
  UPDATE_ENTERPRISE_USER: 'UPDATE_ENTERPRISE_USER',

  GET_TIMEZONES: 'GET_TIMEZONES'
}
export default types
